export default __webpack_public_path__ + "static/media/whatittakes.0bd8df89.png";